<template>
  <Table border :columns="columns" :data="data">
    <AddressList
        slot-scope="{ row, index }"
        slot="receiveAddress"
        :list="row.receiveAddress"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
  </Table>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      columns: [
        {
          title: "客户名称",
          key: "customer",
        },
        {
          title: "订单号",
          key: "ono",
        },
        {
          title: "卡板数",
          key: "pnumber",
        },
        {
          title: "重量/kgs",
          key: "weight",
        },
        {
          title: "件数",
          key: "amount",
        },
        {
          title: "体积/cbm",
          key: "volume",
        },
        {
          title: "唛头",
          key: "mark",
        },
         {
          title: "交货地址",
          slot: "receiveAddress",
        }, 

        {
          title: "备注",
          key: "remark",
        },
        {
          title: "交货时间",
          key: "timesUnloadLeave2",
        },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/chuhuozonglanChild.vue